import React from 'react'


import Github from '../../img/github.png';
import LinkedIn from '../../img/linkedin.png';
import Instagram from '../../img/instagram.png';

const Icon = () => {
  return (

    <div className="i-icons" style={{justifyContent:'center'}}>
        <a href="https://github.com/binarybeauty45" target="_blank"><img src={Github}  alt=""/></a>
        <a href="https://www.linkedin.com/in/binarybeauty45/" target="_blank"><img src={LinkedIn} alt=""/> </a>
        <a href="https://www.instagram.com/riyasm78/" target="_blank"> <img src={Instagram} alt=""/>    </a>
        
   

    </div>

  )
}

export default Icon